<template>
  <div class="pb-6 h-full" v-if="htmlContent" v-html="htmlContent"></div>
</template>

<script setup lang="ts">
import { ref, onMounted, watch } from 'vue';
import { getCustomerHtmlTabs } from '@/services/api/traders';
import type { Material } from '@/types/Materials';

const props = defineProps<{
  material: Material | undefined;
  mode?: 'view' | 'edit';
  isHorizontalLayout?: boolean;
}>();

const htmlContent = ref<string>('');

async function fetchBalance() {
  if (props.material && props.material.boid) {
    const result = await getCustomerHtmlTabs({
      enumValue: 4,
      materialBoid: props.material.boid,
    });
    if (result) htmlContent.value = result;
  }
}

onMounted(fetchBalance);

watch(
  () => props.material?.boid,
  () => {
    htmlContent.value = '';
    fetchBalance();
  }
);
</script>
